import type { FaireProductEntity } from "../../entity_types/product";

export const p_q6px4tywds: FaireProductEntity = {
  token: "p_q6px4tywds",
  type: "product",
  name: "Zero Waste MVMT Shampoo Bar | Variety | Nourishing, Balanced",
  brandToken: "b_7epwzqn7do",
  brandName: "Zero Waste MVMT",
  imageUrl:
    "https://cdn.faire.com/fastly/eb5fa55f0a339dd2438ca792a07f502d8ebff1f9f794771576f8e1c7eceffdc1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b247e8f9d1aef9c1d7808a0714cd8918789627afaf2e72cdc8d12ae6cff26661.jpeg",
    "https://cdn.faire.com/fastly/bcbe39d92fa3692c62af1685ba0bc06172414a273cc62d5e4ef98e378c2667bb.jpeg",
    "https://cdn.faire.com/fastly/89206682239bac09bde0f1221cbff70da84d0c82114abbddfb84c4ab45671c60.jpeg",
    "https://cdn.faire.com/fastly/ead97425ad4ba743fcefdd3e8be9430fbdc0bec72d15dd4310ec6bc9203c37b0.jpeg",
    "https://cdn.faire.com/fastly/163282d5e3c4234263814fb8d5cdb98b04637020f5e3f7054d858549d1332caf.jpeg",
    "https://cdn.faire.com/fastly/95eaecaee0ec8858401b7807b1d359c596859dcbcfcbc4b973e55cd0ad72952b.jpeg",
    "https://cdn.faire.com/fastly/aa9854c46948cbefe6ca86dff7dee3b64f7c2921f9060d741680e9cbfb2ded85.jpeg",
    "https://cdn.faire.com/fastly/d4792654eb52cffba898b21c6e3767537d644f170ee34ee328839bfc6b66eff0.jpeg",
    "https://cdn.faire.com/fastly/db8f9d7681d9ecf2277ea2cf89ce97ccac6de55954893858412ececa27b54544.jpeg",
  ],
  priceDollars: 9.75,
  description:
    "Our Zero Waste Shampoo Bar provides an invigorating, refreshing cleanse that awakens your senses and leaves your hair soft and revitalized—all in a sustainable, plastic-free form. This bar comes in 3 scents, peppermint + eucalyptus, cedar + patchouli, or sweet orange + grapefruit.\n\nInfused with coconut oil and cocoa butter, this bar gently cleanses, smooths frizz, and adds natural shine. Ideal for those who want a clean, eco-\n\n🌱 Just 1 shampoo bar can replace up to 3-250ml bottles of shampoo and last for 50-75+ washes\n\nPackaged in biodegradable travel paperboard tubes, meaning no waste and no plastic packaging. \n\nABOUT ZERO WASTE MVMT\n\nZero Waste MVMT is an eco-conscious brand on a mission to help you live more sustainably with plastic-free reusables and natural, earth-friendly products 🌱  We always ship plastic-free in recycled cardboard boxes and sealed with paper tape. All deliveries are carbon neutral 🌎",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:32.521Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
